<style lang="less" scoped>
.orderList {
    width: 100%;
    min-height: 100%;
    background-color: #f0f2f6;
    .order-item {
        margin-top: 20px;
        width: 100%;
        // height: 612px;
        background-color: #fff;
        padding: 30px;
        padding-top: 0px;
        box-sizing: border-box;
        text-align: left;
        .title {
            width: 100%;
            height: 104px;
            line-height: 104px;
            border-bottom: 1px solid #E7E9EE;
            .t-left {
                float: left;
                font-size:36px;
                font-family:Microsoft YaHei;
                font-weight:400;
                color:rgba(34,34,34,1);
            }
            .t-right {
                float: right;
                font-size:28px;
                font-family:Microsoft YaHei;
                font-weight:400;
                color:rgba(33,170,255,1);
            }
        }
    }
    .list {
        width: 100%;
        margin-top: 20px;
        font-size:28px;
        font-family:Microsoft YaHei;
        font-weight:400;
        overflow: hidden;
        span {
            float: left;
            width: 169px;
            line-height:56px;
            color: #333333;
            // text-align: right;
        }
        .right {
            float: left;
            width: 70%;
            div {
                width: 100%;
                color:#999999;
                line-height:56px;
            }
        }
    }
    .order_bottom {
        width: 100%;
        overflow: hidden;
        .button {
            float: right;
            width:223px;
            height:70px;
            line-height: 70px;
            text-align: center;
            background:rgba(33,170,255,1);
            border-radius:10px;
            font-size:30px;
            font-family:Microsoft YaHei;
            font-weight:400;
            color:rgba(255,255,255,1);
        }
    }
}
</style>

<template>
    <div class="orderList">
        <nut-infiniteloading 
            @loadmore="onInfinite" 
            :is-show-mod="true" 
            :has-more="isHasMore" 
            :is-loading="isLoading" 
            :threshold="200"
        >
        <div class="order-item" v-for="(item,key) in orderListArr" :key="key">
            <div class="title">
                <span class="t-left">订单编号：{{item.id}}</span><span class="t-right">{{item.status_name}}</span>
            </div>
            <div class="list">
                <span>公司名称：</span>
                <div class="right">
                    <!-- <div>{{item.bminfo.company_names}}</div> -->
                    <div v-for="(list,index) in item.bminfo.company_names" :key="index">{{list}}</div>
                </div>
            </div>
            <div class="list">
                <span>经营者代表：</span>
                <div class="right"><div>{{item.bminfo.legal_name}}</div></div>
            </div>
            <div class="list">
                <span>联系电话：</span>
                <div class="right"><div>{{item.bminfo.legal_mobile}}</div></div>
            </div>
            <div class="list">
                <span>创建时间：</span>
                <div class="right"><div>{{item.created_at}}</div></div>
            </div>
            <div class="list">
                <span>订单状态：</span>
                <div class="right">
                    <div>{{item.status_name}}</div> 
                    <div v-if="item.rejectReason && item.auditStatus == 2" style="color:#F56C6C;">{{item.rejectReason}}</div>
                </div>
            </div>
            <div class="order_bottom" @click="details(item)">
                <div class="button">查看详情</div>
                <!-- <div v-if="detailsType == 1" class="button">查看详情</div>
                <div v-else class="button">信息审核</div>  -->
            </div>
        </div>
        </nut-infiniteloading>
    </div>
</template>

<script>
import http from '../../api/index.js'
import config from '../../utils/config.js'

export default {
    data() {
        return {
            orderListArr:[],
            page: 1,
            count: 0,
            detailsType: 1,
            isHasMore: true,
            isLoading: false,
            isErr: false
        }
    },
    mounted () {
        this.page = 1;
        this.orderListArr = []
        var detailsType = sessionStorage.getItem('detailsType')
        this.detailsType = detailsType;
        this.orderPost()
    },
    methods: {
        onInfinite () {
            this.isLoading = true;
            if (this.page <= this.count/10) {
                this.page = this.page + 1;
                this.orderPost()
            } else {
                this.isHasMore = false;
                this.isLoading = false;
            }
        },
        unauditOrdersPost() {
            http.post(config.unauditOrders,{
                currentPage: this.page,
                pageSize: 10,
                auditStatus: 0
            }).then( (e) => {
                if (e.code == 1) {
                    var that = this
                    this.count = e.data.count
                    this.orderListArr = e.data.rows
                    console.log(e)
                    // for (let index = 0; index < e.data.rows.length; index++) {
                    //     var obj = e.data.rows[index].userbiz
                    //     obj.auditStatusName = e.data.rows[index].auditStatusName
                    //     obj.auditStatus = e.data.rows[index].auditStatus
                    //     obj.rejectReason = e.data.rows[index].rejectReason
                    //     obj.type = e.data.rows[index].statusName
                    //     obj.id =  e.data.rows[index].orderNo
                    //     obj.created =  e.data.rows[index].created_at
                    //     obj.companyNamesArr = e.data.rows[index].userbiz.company_names.split('#com#')
                    //     that.orderListArr.push(obj)
                    // }
                }
                // wx.stopPullDownRefresh();
            })
        },
        orderPost() {
            http.post(config.myOrders,{
                currentPage: this.page,
                pageSize: 10
            }).then( (e) => {
                if (e.code == 1) {
                    console.log(e,'??????????')
                    var that = this
                    this.count = e.data.count
                    this.orderListArr = e.data.rows
                    if(this.orderListArr) {
                        for(let order of this.orderListArr) {
                            if(order.bminfo) {
                                // order.bminfo.company_names = (order.bminfo.company_names || "").split("#com#").join("、");
                                order.bminfo.company_names = (order.bminfo.company_names || "").split("#com#");
                            }
                        }
                    }
                }
                this.isLoading = false;
            })
        },
        details(item) {
            const url = '/orderDetails'
            this.$router.push({ path: url , query: { item: JSON.stringify(item) }});
        }
    },
    components: {

    }
}
</script>


// WEBPACK FOOTER //
// src/pages/orderList/index.vue